import request from '../request';

const server = {
  // 采购商查询-采购专属区采购-月   采购趋势
  queryOrderByMonth(params) {
    return request.post('/data-center/purchaseZone/queryOrderByMonth', params);
  },
  queryOrderMonthForZoneShareAll(params) {
    return request.post(
      '/data-center/purchaseZone/queryOrderMonthForZoneShareAll',
      params,
      {
        preventRepeat: false,
      }
    );
  },
  // 采购商查询-采购专属区采购-供应商/部门   采购金额排行
  queryOrderBySupplierAndDepartment(params) {
    return request.post(
      '/data-center/purchaseZone/queryOrderBySupplierAndDepartment',
      params,
      {
        preventRepeat: false,
      }
    );
  },
  //采购占比-采购员
  queryOrderByMember(params) {
    return request.post('/data-center/purchaseZone/queryOrderByMember', params, {preventRepeat: false,});
  },
  //采购数量
  queryDataOverviewCount(params) {
    return request.post('/data-center/purchaseZone/queryDataOverviewCount', params, {preventRepeat: false,});
  },
  //采购金额
  queryDataOverviewAmount(params) {
    return request.post('/data-center/purchaseZone/queryDataOverviewAmount', params, {preventRepeat: false,});
  },
  //数据详情
  queryDataInfo(params) {
    return request.post('/data-center/purchaseZone/queryDataInfo', params,);
  },
  //采购员们
  queryMemberList(params) {
    return request.post('/data-center/purchaseZone/queryMemberList', params,);
  },
  //数据详情-导出
  exportDataInfo(params) {
    return request.post('/data-center/purchaseZone/queryDataInfo/export', params, {responseType: 'blob',});
  },
  //数据总览-导出
  exportDataOverview(params) {
    return request.post('/data-center/purchaseZone/queryDataOverview/export', params, {responseType: 'blob',});
  },

  // 采购商查询-采购专属区采购-物料编码   采购计划分布
  queryOrderLbbm(params) {
    return request.post('/data-center/purchaseZone/queryOrderLbbm', params);
  },
  // 采购商查询-采购专属区采购-采购计划   物料大类分布
  queryOrderType(params) {
    return request.post('/data-center/purchaseZone/queryOrderType', params);
  },
  queryCategoryTree(params) {
    return request.post(
      '/data-center/purchaseZoneUsuallyCategory/queryCategoryTree',
      params
    );
  },
  enquiryPurchaseCountStatistical(params) {
    return request.post(
      '/transaction-center/EnquiryStatistics/enquiryPurchaseCountStatistical',
      params
    );
  },
  // 采购计划任务统计招标数量
  purchasePlanTenderingStatistical(params) {
    return request.post(
      '/bidding/tendering/purchasePlanTenderingStatistical',
      params
    );
  },
  // 采购计划任务订单数量统计
  orderPurchaseCountStatistical(params) {
    return request.post(
      '/transaction-center/OrderStatistic/orderPurchaseCountStatistical',
      params
    );
  },
  // 采购计划任务统计
  purchasePlanStatistical(params) {
    return request.post(
      '/purchase/purchaseStatistical/purchasePlanStatistical',
      params
    );
  },
  // 查询采购商对应的协议
  getAgreementListForPurchase(params) {
    return request.post(
      '/product/agreement/queryAgreementForPurchaseByPage',
      params
    );
  },
  // 查询待审批任务数量
  queryCountWaitApprove(params) {
    return request.post(
      '/purchase/businessAudit/queryCountWaitApprove',
      params
    );
  },
  // 菜单接口
  memberMenuTree(params) {
    return request.post('/ubm/purchaseAreaSystem/memberMenuTree', params, {
      preventRepeat: false,
    });
  },
  // 采购商查询-采购专属区采购-月   采购趋势
  querySinochemOrderList(params) {
    return request.post(
      '/data-center/purchaseZone/querySinochemOrderList',
      params
    );
  },
  // 采购商查询-采购专属区采购-部门   采购金额排行
  querySinochemOrderByDepartment(params) {
    return request.post(
      '/data-center/purchaseZone/querySinochemOrderByDepartment',
      params
    );
  },
  // 采购商查询-采购专属区采购-采购方式 采购金额供应商
  querySinochemOrderBySupplier(params) {
    return request.post(
      '/data-center/purchaseZone/querySinochemOrderBySupplier',
      params
    );
  },
  // 采购商查询-采购专属区采购-物料编码    物资大类分布
  querySinochemOrderByCategory(params) {
    return request.post(
      '/data-center/purchaseZone/querySinochemOrderByCategory',
      params
    );
  },

  // 工作台 数据展示
  // 代办订单接口
  supplier(params) {
    return request.post('/transaction-center/orderToDo/supplier', params);
  },
  // 1.查询待修改品牌数量
  querySupplyCompanyBrandAuditPage(params) {
    return request.post(
      '/product/brandAudit/querySupplyCompanyBrandAuditPage',
      params
    );
  },
  // 2.查询待修改的规格属性数量
  queryAttributeAuditPageByCompany(params) {
    return request.post(
      '/product/attributeAudit/queryAttributeAuditPageByCompany',
      params
    );
  },
  // 3.查询待修改商品的数量
  queryReleaseProductByPageData(params) {
    return request.post(
      '/product/auditManagement/queryReleaseProductByPage',
      params
    );
  },
  // 4.查询待添加商品协议：
  queryAgreementForSupplierByPage(params) {
    return request.post(
      '/product/agreement/queryAgreementForSupplierByPage',
      params
    );
  },
  // 询比价统计接口
  querySupplierOfferCount(params) {
    return request.post(
      '/transaction-center/EnquiryStatistics/querySupplierOfferCount',
      params
    );
  },

  //
  queryOrderDataByMonth(params) {
    return request.post(
      '/data-center/purchaseZone/queryOrderDataByMonth',
      params,
      { preventRepeat: false }
    );
  },
  // purchaseZone/queryOrderMonthOnMonthRatio
  queryOrderMonthOnMonthRatio(params) {
    return request.post(
      '/data-center/purchaseZone/querySupplierOrderMonthOnMonthRatio',
      params
    );
  },
  queryCompanyStores(params) {
    return request.fetch('/user-center/store/queryCompanyStores', params);
  },
  hasAuthCode(params) {
    return request.post('/ubm/member/hasAuthCode', params);
  },
  //  销售环比
  querySupplierOrderMonthOnMonthRatio(params) {
    return request.post(
      '/data-center/purchaseZone/querySupplierOrderMonthOnMonthRatio',
      params
    );
  },
  // queryOrderLbbmForSupplier
  queryOrderLbbmForSupplier(params) {
    return request.post(
      '/data-center/purchaseZone/queryOrderLbbmForSupplier',
      params
    );
  },
  // 查询待确认及已确认数量 易专采工作台（采购商维度）
  queryBrushingOrderCount(params) {
    return request.post(
      '/transaction-center/suspectedBrushingOrder/queryBrushingOrderCount',
      params
    );
  },

  setPVUV(params) {
    return request.post(
      '/user-behavior-collector/behavior/addPageEvent',
      params
    );
  },
};
export default server;
